/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './hardware-entities.scss';

/*@ngInject*/
export default function HardwareEntitiesController($translate, $mdDialog, gatewayService, gatewayModelService, gatewayGroupService,
                                                   providerService, deviceService, deviceModelService, customerService, applicationService) {
    var vm = this;

    vm.$onInit = function () {
        vm.entityStateText = '';

        vm.gatewayInputMac = '';
        vm.gatewayEntity = {};
        vm.deviceInputEui = '';
        vm.deviceEntity = {};

        vm.getGatewayByMac = getGatewayByMac;
        vm.getDeviceByEui = getDeviceByEui;
        vm.deleteGateway = deleteGateway;
        vm.deleteDevice = deleteDevice;
    };

    function getGatewayByMac() {
        if (vm.gatewayInputMac) {
            var gatewayPromise = gatewayService.getSystemGatewayByMac(vm.gatewayInputMac);
            if (gatewayPromise) {
                gatewayPromise.then(
                    (gateway) => {
                        if (!angular.equals('', gateway)) {
                            vm.entityStateText = '';

                            vm.gatewayEntity.id = gateway.id.id;
                            vm.gatewayEntity.name = gateway.name;
                            getGatewayModelName(gateway.gatewayModelId.id);
                            vm.gatewayEntity.mac = gateway.mac;
                            getGatewayGroupName(gateway.gatewayGroupId.id);
                            getProviderName(gateway.providerId.id);
                            vm.gatewayEntity.customerName = gateway.customerTitle;
                        } else {
                            resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                        }
                    },
                    () => {
                        resetEntityState($translate.instant('hardware-entities.gateway-not-found-text', {mac: vm.gatewayInputMac}));
                    });
            }
        }
    }

    function deleteGateway($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('gateway.delete-gateway-title', {name: vm.gatewayEntity.name}))
            .htmlContent($translate.instant('gateway.delete-gateway-text'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                gatewayService.deleteSystemGateway(vm.gatewayEntity.id).then(function success() {
                    vm.gatewayInputMac = '';
                    resetEntityState($translate.instant('hardware-entities.gateway-was-deleted', {mac: vm.gatewayEntity.mac}));
                })
            },
            function () {
            })
    }

    function getGatewayModelName(gatewayModelId) {
        var gatewayModelPromise = gatewayModelService.getSystemGatewayModel(gatewayModelId);
        if (gatewayModelPromise) {
            gatewayModelPromise.then(
                (gatewayModel) => {
                    vm.gatewayEntity.modelName = gatewayModel.name;
                },
                () => {
                    vm.gatewayEntity.modelName = '';
                }
            );
        }
    }

    function getGatewayGroupName(gatewayGroupName) {
        var gatewayGroupPromise = gatewayGroupService.getSystemGatewayGroup(gatewayGroupName);
        if (gatewayGroupPromise) {
            gatewayGroupPromise.then(
                (gatewayGroup) => {
                    vm.gatewayEntity.groupName = gatewayGroup.name;
                },
                () => {
                    vm.gatewayEntity.groupName = '';
                }
            );
        }
    }

    function getProviderName(providerId) {
        var providerServicePromise = providerService.getProvider(providerId);
        if (providerServicePromise) {
            providerServicePromise.then(
                (provider) => {
                    vm.gatewayEntity.providerName = provider.name;
                    vm.deviceEntity.providerName = provider.name;
                },
                () => {
                    vm.gatewayEntity.providerName = '';
                    vm.deviceEntity.providerName = '';
                }
            );
        }
    }

    function getDeviceByEui() {
        if (vm.deviceInputEui) {
            var devicePromise = deviceService.getSystemDeviceByEui(vm.deviceInputEui);
            if (devicePromise) {
                devicePromise.then(
                    (device) => {
                        if (!angular.equals('', device)) {
                            vm.entityStateText = '';

                            vm.deviceEntity.id = device.id.id;
                            vm.deviceEntity.name = device.name;
                            getDeviceModelName(device.deviceModelId.id);
                            vm.deviceEntity.eui = device.deviceEUI;
                            getProviderName(device.providerId.id);
                            getCustomerName(device.customerId.id);
                            getApplicationName(device.applicationId.id);
                        } else {
                            resetEntityState($translate.instant('hardware-entities.device-not-found-text', {eui: vm.deviceInputEui}));
                        }
                    },
                    () => {
                        resetEntityState($translate.instant('hardware-entities.device-not-found-text', {eui: vm.deviceInputEui}));
                    });
            }
        }
    }

    function deleteDevice($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var confirm = $mdDialog.confirm()
            .targetEvent($event)
            .title($translate.instant('device.delete-device-title', {name: vm.deviceEntity.name}))
            .htmlContent($translate.instant('device.delete-device-text'))
            .cancel($translate.instant('action.no'))
            .ok($translate.instant('action.yes'));
        $mdDialog.show(confirm).then(function () {
                deviceService.deleteSystemDevice(vm.deviceEntity.id).then(function success() {
                    vm.deviceInputEui = '';
                    resetEntityState($translate.instant('hardware-entities.device-was-deleted', {eui: vm.deviceEntity.eui}));
                })
            },
            function () {
            })
    }

    function getDeviceModelName(deviceModelId) {
        var deviceModelServicePromise = deviceModelService.getSystemDeviceModel(deviceModelId);
        if (deviceModelServicePromise) {
            deviceModelServicePromise.then(
                (deviceModel) => {
                    vm.deviceEntity.modelName = deviceModel.name;
                },
                () => {
                    vm.deviceEntity.modelName = '';
                }
            );
        }
    }

    function getCustomerName(customerId) {
        var customerServicePromise = customerService.getSystemCustomer(customerId);
        if (customerServicePromise) {
            customerServicePromise.then(
                (customer) => {
                    vm.deviceEntity.customerName = customer.name;
                },
                () => {
                    vm.deviceEntity.customerName = '';
                }
            );
        }
    }

    function getApplicationName(applicationId) {
        var applicationServicePromise = applicationService.getSystemApplication(applicationId);
        if (applicationServicePromise) {
            applicationServicePromise.then(
                (application) => {
                    vm.deviceEntity.applicationName = application.name;
                },
                () => {
                    vm.deviceEntity.applicationName = '';
                }
            );
        }
    }

    function resetEntityState(stateText) {
        vm.entityStateText = stateText;
        vm.gatewayEntity = {};
        vm.deviceEntity = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/hardware-entities/hardware-entities.controller.js